import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'feature-loading-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.css'],
  standalone: false,
})
export class SkeletonComponent implements OnInit {
  @Input() width: string = '100%';
  @Input() height: string = '1.5rem';
  @Input() size: string | undefined = undefined;
  @Input() shape: string = 'rectangle';
  @Input() borderRadius: string = '16px';
  @Input() className: string = '';

  constructor() {}

  ngOnInit(): void {}
}
